import pkg from '../../package.json';
const { version } = pkg;
export default version;
